import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import type { GlassHouseBrandGroupCardData } from '../../../../../../../../../models/print-cards/glass-house/glass-house-brand-group-card-data';
import { RenderContextComponent } from '../../../../../../../../../models/base/render-context-component';

@Component({
  selector: 'app-glass-house-variant-type-and-label',
  templateUrl: './glass-house-variant-type-and-label.component.html',
  styleUrl: './glass-house-variant-type-and-label.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class GlassHouseVariantTypeAndLabelComponent extends RenderContextComponent {
  @Input() data: GlassHouseBrandGroupCardData;
  @Input() hasLabelText: boolean;
  @Input() viewingInLiveView: boolean;
  setupViews() {}
  setupBindings() {}
}
